import { useMemo, useState } from 'react'
import { OverrideUiSchemaProps, UiSchema } from '../types/schema.js'
import { useBasedSchema } from '../providers/Endpoints/index.js'
import { useDependency } from './useDependency.js'

type UseUiSchemaProps = {
  schemaType: string
  overrideProps?: OverrideUiSchemaProps
  hideProps?: Set<string>
  showProps?: Set<string>
}

export const useUiSchema = ({
  schemaType,
  overrideProps,
  hideProps,
  showProps,
}: UseUiSchemaProps) => {
  const { data: schemaData, checksum: schemaChecksum } = useBasedSchema()

  const uiSchemaMemo: UiSchema = useMemo(() => {
    if (!schemaData || !schemaChecksum || !schemaType) {
      return {}
    }

    const schemaObject = { ...schemaData.types[schemaType] }
    let schemaProps = {
      // @ts-ignore
      ...schemaObject?.props,
    }

    if (hideProps?.has('id') || !showProps?.has('id')) {
      schemaProps = {
        ...schemaProps,
        id: {
          type: 'number',
          hide: true,
        },
      }
    }

    for (const prop in schemaProps) {
      if (overrideProps?.[prop]) {
        schemaProps[prop] = {
          ...schemaProps[prop],
          ...overrideProps[prop],
        }
      }

      if (hideProps?.has(prop) && !showProps?.has(prop)) {
        schemaProps[prop].hide = true
      }
    }

    if (showProps && showProps.size > 0) {
      const reordered: OverrideUiSchemaProps = {}

      for (const key of showProps) {
        if (schemaProps[key]) {
          reordered[key] = {
            ...schemaProps[key],
            hide: false,
          }
        }
      }

      for (const key in schemaProps) {
        if (!reordered[key]) {
          reordered[key] = {
            ...schemaProps[key],
            hide: true,
          }
        }
      }

      schemaProps = reordered
    }

    const result = {
      ...schemaData,
      types: {
        ...schemaData.types,
        [schemaType]: {
          ...schemaObject,
          props: {
            ...schemaProps,
          },
        },
      },
    }

    return result
  }, [
    useDependency(hideProps),
    useDependency(showProps),
    useDependency(overrideProps),
    schemaType,
    schemaChecksum,
  ])

  return uiSchemaMemo
}
